const RELOAD_GUARD_KEY = '__chunk_reload_guard__';
const RETRY_QUERY_KEY = '__chunk_retry__';

const CHUNK_URL_PATTERN = /\/static\/(css|js)\/.+\.chunk\.(css|js)(\?|$)/i;
const CHUNK_ERROR_PATTERN =
  /chunkloaderror|loading (css )?chunk [^\s]+ failed|css_chunk_load_failed|failed to fetch dynamically imported module|unexpected token '<'/i;

function isChunkUrl(url?: string | null): boolean {
  if (!url) {
    return false;
  }
  return CHUNK_URL_PATTERN.test(url);
}

function shouldHandleMessage(message: string): boolean {
  return CHUNK_ERROR_PATTERN.test(message.toLowerCase());
}

function forceReloadWithCacheBust(): void {
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || '0');
  const now = Date.now();
  if (lastReloadAt && now - lastReloadAt < 10000) {
    return;
  }

  sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set(RETRY_QUERY_KEY, String(now));
  window.location.replace(nextUrl.toString());
}

function cleanRetryQuery(): void {
  const currentUrl = new URL(window.location.href);
  if (!currentUrl.searchParams.has(RETRY_QUERY_KEY)) {
    return;
  }
  currentUrl.searchParams.delete(RETRY_QUERY_KEY);
  window.history.replaceState(null, '', currentUrl.toString());
}

export function setupChunkLoadRecovery(): void {
  cleanRetryQuery();

  window.addEventListener(
    'error',
    (event) => {
      const target = event.target as EventTarget | null;
      let url = '';
      if (target instanceof HTMLLinkElement) {
        url = target.href;
      } else if (target instanceof HTMLScriptElement) {
        url = target.src;
      }

      if (isChunkUrl(url) || (isChunkUrl(event.filename) && shouldHandleMessage(event.message || ''))) {
        forceReloadWithCacheBust();
      }
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message =
      typeof reason === 'string'
        ? reason
        : reason?.message || reason?.name || '';

    if (shouldHandleMessage(message)) {
      forceReloadWithCacheBust();
    }
  });
}
